<div class="line-left"></div>
<div class="label">
  @if (icon) {
    <ppl-icon
      [svgIcon]="icon"
      width="16px"
      height="16px"></ppl-icon>
  }
  @if (label) {
    <div>
      {{ label }}
    </div>
  }
  @if (labelTemplate) {
    <div>
      <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
    </div>
  }
  @if (infoMessage) {
    <ppl-information-icon
      [message]="infoMessage"
      class="info-icon"></ppl-information-icon>
  }
</div>
<div class="line-right"></div>
@if (actionTemplate) {
  <div class="action">
    <ng-container *ngTemplateOutlet="actionTemplate"></ng-container>
  </div>
}
